// assets/inventory-sync.js
(function initInventorySync() {
  function getInventoryMapForForm(form) {
    const tag = form.querySelector('script[data-inventory-json]');
    if (!tag) return null;
    try {
      const arr = JSON.parse(tag.textContent || '[]');
      return arr.reduce((m, x) => ((m[String(x.id)] = Number(x.qty) || 0), m), {});
    } catch (e) {
      console.warn('[inventory-sync] Bad JSON in data-inventory-json', e);
      return null;
    }
  }

  function computeInvValue(variant, invMap) {
    if (!variant) return '';
    // Safeguard requested: zero when unavailable
    if (variant.available === false) return 0;

    // Prefer event payload if present
    if (typeof variant.inventory_quantity === 'number') return variant.inventory_quantity;

    // Fallback to Liquid-provided inventory map
    if (invMap && variant.id && invMap[String(variant.id)] != null) {
      return invMap[String(variant.id)];
    }
    return '';
  }

  function updateFormProperty(form, value) {
    const input = form.querySelector('input[name="properties[_inventory_Quantity]"]');
    if (input) input.value = value;
  }

  function onVariantChange(event) {
    // Impact targets the *form* that changed; be defensive in case of wrappers
    const form = (event.target && event.target.closest)
      ? (event.target.closest('form') || event.target)
      : event.target;
    if (!form || !form.querySelector) return;

    const invMap = getInventoryMapForForm(form);
    const variant = event.detail && event.detail.variant;
    const val = computeInvValue(variant, invMap);
    updateFormProperty(form, val);
  }

  function start() {
    // Single global listener covers product page, featured product, quick add
    document.addEventListener('variant:change', onVariantChange);
  }

  // Load non-blocking
  if ('requestIdleCallback' in window) {
    requestIdleCallback(start, { timeout: 1500 });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
